import { Button, Col, Container, Form, Row } from 'react-bootstrap';

import Iframe from 'react-iframe'
import React from 'react';
import classes from '../HeadingComponent.module.css';
import classesContact from './AboutContent.module.css';

function ContactForm() {
	return (
		<Container fluid className={classes.container}>
			<div className={classes.headingCard}><a href="/">about</a></div>
			<Container>
				<Row className={classesContact.map}>
					<Iframe className={classesContact.iframe} src="https://www.google.com/maps/embed/v1/place?q=minneapolis,+mn&key=AIzaSyBFw0Qbyq9zTFTd-tUY6dZWTgaQzuU17R8&zoom=11" />
				</Row>

				<Row className={classesContact.contact}>
					<Col lg={4}>
						<Col>
							<span className={classesContact.icons}>
								<i class="far fa-compass"></i>
							</span>
							<p className={classesContact.col1B}>Minneapolis, MN</p>
						</Col>
						<Col>
							<span className={classesContact.icons}>
								<i class="far fa-envelope"></i>
							</span>
							<p className={classesContact.col1B}><a className={classesContact.link} href="mailto:lawanscott@gmail.com" alt="">Lawanscott@gmail.com</a></p>
						</Col>
					</Col>
					
					<Col lg={8} className={classesContact.bottomSpace}>
						<p>This is a tiny corner of the internet for Scott Lawan and is not a professional space . . .</p>
						<p>. . . THAT Scott Lawan is a libraries/archives professional with over a decade of experience and his professional website may be seen here: <a href="https://www.scottlawan.co/" target="_blank">scottlawan.co</a></p>
					</Col>
				</Row>
			</Container>
		</Container>
	);
}

export default ContactForm;